import { apiGet, apiSend } from './http-client'
import { authUser } from './auth-store'
const key=()=>`ema.org.database.${authUser.value?.personId||'anonymous'}`
export const orgRepo={
 list:()=>apiGet<Record<string,any>[]>('/api/orgs'),
 current:()=>apiGet<Record<string,any>>('/api/orgs/current',{org:orgRepo.id()}),
 set:(id:string)=>apiSend<Record<string,any>>('PUT','/api/orgs/current',{id}),
 id():string {try{return sessionStorage.getItem(key())||''}catch{return ''}}
}
export function rememberOrgSelection(id:string){try{if(id)sessionStorage.setItem(key(),id);else sessionStorage.removeItem(key())}catch{/* Selection need not persist in restricted browsers. */}}
